import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogContent, DialogTrigger, Icon } from "@tenant/ui";
import { PerkDialogButtons } from "./PerkDialogButtons";
import { PerkDialogItem } from "./PerkDialogItem";
import styles from "./PerkDialogs.module.scss";
import { LOWEST_PRICE_RULE_URL } from "@/utils/externalPages";

export const LowestRateDialog = () => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");
  const { t } = useI18nContext();

  return (
    <PerkDialogItem
      iconName={IconNameEnum.homepagePerkRight}
      title={t("home.perks.lowestRate.title")}
    >
      <Dialog>
        <DialogTrigger className={cn("item-dialog-trigger")}>
          {t("home.perks.lowestRate.trigger")}
        </DialogTrigger>
        <DialogContent
          bottomFixedContent={
            <PerkDialogButtons rulesUrl={LOWEST_PRICE_RULE_URL} />
          }
          className={cn("item-dialog-content")}
          showCloseButton={false}
        >
          <Icon
            iconName={IconNameEnum.homepagePerkRight}
            className={cn("dialog-icon")}
            useCurrentColor={false}
          />
          <h2 className={cn("dialog-title")}>
            {t("home.perks.lowestRate.dialogTitle")}
          </h2>
          <p className={cn("dialog-section-text")}>
            {t("home.perks.lowestRate.description")}
          </p>
        </DialogContent>
      </Dialog>
    </PerkDialogItem>
  );
};
